import { PointId } from './point-node';

/**
 * The graph node flags keep track of which nodes are traversed and which are dead ends based on index.
 */
export class NodeTraversalFlags {
  private flags;

  constructor() {
    this.flags = new Map<PointId, boolean>();
  }

  /**
   * Marks a node as being traversed.
   */
  setTraversed(pointId: PointId) {
    this.flags.set(pointId, true);
  }

  /**
   * Marks a node as a dead end, Meaning that it does not connect into a polygon.
   */
  setDeadEnd(pointId: PointId) {
    return this.flags.set(pointId, false);
  }

  isTraversed(pointId: PointId) {
    return this.flags.has(pointId);
  }

  isDeadEnd(pointId: PointId) {
    return this.flags.get(pointId) === false;
  }
}
